import { render, staticRenderFns } from "./ShippingAdd.vue?vue&type=template&id=d77c1c2a"
import script from "./ShippingAdd.vue?vue&type=script&lang=js"
export * from "./ShippingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports